import React, { useState, useEffect, useRef, FC } from 'react'
import useNetwork from '@/checkout-instore-legacy/hooks/useNetwork'
// TODO: this error popped up when moving the checkout-instore project
// to checkout-instore-legacy, but needs to be fixed at some point
// @ts-ignore
import { useNetworkStatus } from 'react-adaptive-hooks/network'
import Alert from '@vtex/styleguide/lib/Alert'
import { logClickEvent } from '@/checkout-instore-legacy/utils/EventHelper'
import { FormattedMessage } from 'react-intl'

export interface NetworkMessageProps {
  updateCart: () => void
  intl?: IntlObject
}

const NetworkMessage: FC<NetworkMessageProps> = ({ updateCart, intl }) => {
  const isOnline = useNetwork()
  const [isVisible, setIsVisible] = useState(false)
  const [checkConnection, setCheckConnection] = useState(false)
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)
  const [messageProperties, setMessageProperties] = useState({
    messageId: '',
    messageType: '',
  })

  const { effectiveConnectionType, unsupported } = useNetworkStatus()

  const setOnline = () => {
    setMessageProperties({
      messageId: 'networkConnectionConnected',
      messageType: 'success',
    })
    timeoutRef.current = setTimeout(() => {
      if (isOnline) {
        setIsVisible(false)
      }
    }, 3000)
  }

  useEffect(() => {
    if (!isOnline) {
      setMessageProperties({
        messageId: 'networkConnectionDisconnected',
        messageType: 'error',
      })
      timeoutRef.current && clearTimeout(timeoutRef.current)
      setIsVisible(true)
    } else {
      if (unsupported) {
        setOnline()
      } else {
        switch (effectiveConnectionType) {
          case 'slow-2g':
          case '2g':
            setMessageProperties({
              messageId: 'networkConnectionUnstable',
              messageType: 'warning',
            })
            timeoutRef.current && clearTimeout(timeoutRef.current)
            setIsVisible(true)
            break
          case '3g':
          case '4g':
            setOnline()
            break
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOnline, unsupported, effectiveConnectionType, checkConnection])

  useEffect(() => {
    if (isOnline && isVisible) {
      updateCart()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOnline])

  if (!isVisible) {
    return null
  }

  const messageAction = () => {
    if (!isOnline) {
      return {
        label: intl?.formatMessage({ id: 'networkReconnect' }),
        onClick: () => {
          setCheckConnection(!checkConnection)
          logClickEvent('reconnect', 'network-message')
          return true
        },
      }
    }
    return undefined
  }

  return (
    <div
      data-testid="network-message"
      className="z-999 absolute shadow-6 mt8 vw-90 vw-30-l self-center"
    >
      <Alert
        type={messageProperties.messageType}
        onClose={
          isOnline
            ? () => {
                setIsVisible(false)
              }
            : undefined
        }
        action={messageAction()}
      >
        <FormattedMessage id={messageProperties.messageId} />
      </Alert>
    </div>
  )
}

export default NetworkMessage
